import { getClampArea, createStyle, setInlineStyle } from '../commons';

export const fillBetween = (context) => {
    const { stylesCache, boundaries } = context;
    const stickyBoundary = boundaries.get('sticky');
    const clampArea = getClampArea(boundaries);

    const checkforplpsrp = () => {
        let pageType = false;
        if (!__SERVER__) {
            const currentPgae = location.href;
            const gPatt = new RegExp(/\/g(?=\/|\?).*/g);
            const sPatt = new RegExp(/\/s(?=\/|\?).*/g);
            if (gPatt.test(currentPgae) || sPatt.test(currentPgae)) {
                pageType = true;
            }
        }
        return pageType;
    };

    if (!stickyBoundary || !clampArea.height) {
        return;
    }
    const minHeight =
        stickyBoundary?.params?.minHeight ||
        stickyBoundary?.element?.getBoundingClientRect()?.height;

    const { activeClass } = stickyBoundary?.params;
    const nextPosition = {};
    // check for PLP/SRP to avoid overlapping with bottom
    if (!checkforplpsrp()) {
        nextPosition.maxHeight = clampArea?.height;
    }

    if (clampArea?.top === 0 || clampArea?.top === clampArea?.offsets?.top) {
        nextPosition.position = 'fixed';

        if (activeClass) {
            stickyBoundary?.element?.classList?.add(activeClass);
        }

        if (minHeight && clampArea?.height > minHeight) {
            nextPosition.top = 0 + clampArea?.offsets?.top;
        } else {
            // check for PLP/SRP to avoid overlapping with bottom
            if (!checkforplpsrp()) {
                nextPosition.maxHeight = minHeight;
            }
            const bottomVal = window?.innerHeight - clampArea?.bottom;
            nextPosition.bottom = bottomVal;
            if (checkforplpsrp()) {
                if (bottomVal < 0) {
                    nextPosition.top = 0;
                } else if (bottomVal > 0) {
                    nextPosition.marginBottom = 50;
                }
            }
        }

        // Because the sticky element must follow parent width in case the parent has auto or a percentage width.
        nextPosition.width = stickyBoundary?.element?.parentElement?.getBoundingClientRect()?.width;
    } else {
        nextPosition.position = 'absolute';
        nextPosition.top = 0;

        if (activeClass) {
            stickyBoundary?.element?.classList?.remove(activeClass);
        }
    }

    const style = createStyle(nextPosition);
    setInlineStyle(stickyBoundary, style, stylesCache);
};

export default fillBetween;
